import store from "store/store";

export const getAuthHeader = (): string => {
	const state = store.getState();
	const accessToken = state.auth.data.access_token;
	return accessToken ? `Bearer ${accessToken}` : "";
};
